import {
    IAccountStatistic,
} from '../types/account-statistic';

import {
    useState,
} from 'react';

import {
    cancelAccountStatisticFetch,
} from '../fetches/cancel-account-statistic.fetch';
import {
    getAccountStatisticFetch,
} from '../fetches/get-account-statistic.fetch';
import {
    IGetAccountStatisticDto,
} from '../requests/get-account-statistic.dto';
import {
    ICancelAccountStatisticResponse,
} from '../responses/cancel-account-statistic.response';
import {
    IGetAccountStatisticResponse,
} from '../responses/get-account-statistic.response';

export function useAccountStatistic() {
    const [accountStatistic, setAccountStatistic] = useState<IAccountStatistic | null>(null);

    const getAccountStatistic = async (encodedId: string, dto: IGetAccountStatisticDto): Promise<IGetAccountStatisticResponse> => {
        const res = await getAccountStatisticFetch(encodedId, dto);

        if (!res.accountStatistic || res.error) {
            console.log(res.error);

            return res;
        }

        setAccountStatistic({
            ...res.accountStatistic,
            // Пока бэкенд раскатывается, под с прежним релизом отдаёт сумму только в amount.
            // TODO(kopecks stage 3): сохранять res.accountStatistic как есть вместе с удалением amount из типа.
            amountKopecks: res.accountStatistic.amountKopecks ?? res.accountStatistic.amount!,
        });

        return res;
    };

    const cancelAccountStatistic = async (encodedId: string): Promise<ICancelAccountStatisticResponse> => {
        const res = await cancelAccountStatisticFetch(encodedId);

        if (res.error) {
            console.log(res.error);
        }

        return res;
    };

    return {
        accountStatistic,
        getAccountStatistic,
        cancelAccountStatistic,
    };
}
